import React, { useEffect, useState, Fragment } from 'react';
import { DataGrid, esES } from '@material-ui/data-grid';
import GridContainer from 'components/Grid/GridContainer';
import GridItem from 'components/Grid/GridItem';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import { makeStyles } from '@material-ui/core/styles';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import Button from 'components/CustomButtons/Button';
import { useParams } from 'react-router-dom';
import { Add, Edit, Visibility } from '@material-ui/icons';
import { MenuItem, Select, InputLabel, FormControl, TextField, Tooltip } from '@material-ui/core';
import { Toasty, useToasty } from 'hooks/Toasty';
import { onlyMoney } from 'hooks/Pipe';

import { wsFindBy, wsUpdate, wsGet, wsGetAll } from 'services/WService';
import { WithApp } from 'contexts/appContext';
import FilterArticle from 'hooks/FilterArticle';
import { wsUpdateMasive } from 'services/WService';
import { useModal } from 'hooks/useModal';
import ModalPrice from './Modal';
import Divider from 'components/Tvendo/Common/Divider';
import DifferenceListModal from './DifferenceListModal';
import DifferenceListPricesModal from './DifferenceListPricesModal';
import UpdateListModal from './UpdateListModal';
import PriceLogModal from './PriceLogModal';

const useStyles = makeStyles({
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px',
  },
  root: {
    '& .row-retained': {
      backgroundColor: '#FFA6A6 !important',
      '&:hover': { backgroundColor: '#FFA6A6' },
    },
  },
});

export default WithApp(function Price(props) {
  const classes = useStyles();
  const [notify, showNotify] = useToasty();

  const { id } = useParams();
  const [model, setOpen] = useModal();
  const [updateListModel, setUpdateListModel] = useModal();
  const [differenceListModel, setDifferenceListModel] = useModal();
  const [priceLogModel, setPriceLogModel] = useModal();
  const [differencePrices, setDifferencePrices] = useState([]);
  const [differenceList, setDifferenceList] = useState({});

  const [pageSize, setPageSize] = useState(10);

  const [prices, setPrices] = useState([]);
  const [textInput, setTextInput] = useState('');

  const [priceList, setPriceList] = useState({});
  const [filters, setFilters] = useState({});
  const [valueSearch, setValueSearch] = useState({});
  const [clearDiscountPackage, setClearDiscountPackage] = useState(false);
  const [dataEdit, setDataEdit] = useState({});
  const [globalDiscount, setGlobalDiscount] = useState(null);
  const [packageVariation, setPackageVariation] = useState('');

  const handlePageSizeChange = (params) => {
    setPageSize(params.pageSize);
  };

  const [multiple, setMultiple] = useState({});
  const changeMultiple = (e) => {
    setMultiple({
      ...multiple,
      [e.target.name]: e.target.value,
    });
  };

  async function listPrices(valueSearch) {
    let newData = { logi_price_list_id: id, ...valueSearch };
    setValueSearch(newData);
    setFilters(newData);
    let response = await wsFindBy('logi/price', newData);
    if (response.success) {
      setPrices(response.data);
    } else {
      showNotify(response.message, 'info');
    }
  }

  async function getPriceList() {
    let response = await wsGet('logi/price-list', id);
    if (response.success) setPriceList(response.data);
  }

  function processSave() {
    if (Object.keys(dataEdit).length > 0) {
      saveData(dataEdit.id, { [dataEdit.field]: parseFloat(dataEdit.props.value) });
    }
  }

  async function saveData(dataEditId, dataEdit) {
    let response = await wsUpdate('logi/price', dataEditId, dataEdit);
    if (response.success) {
      showNotify(response.message);
      listPrices(valueSearch);
      setDataEdit({});
    } else {
      // Actualizar precio a retenido
      if (!!response.data && !!response.data.id) {
        setPrices((prices) => {
          let newPrices = [...prices];
          let index = newPrices.findIndex((price) => price.id === response.data.id);
          if (index > -1) {
            newPrices[index] = response.data;
          }
          return newPrices;
        });
      }
      showNotify(response.message, 'error');
    }
  }

  async function updateMasive(filters, data) {
    /* console.log('antes de guardar', data); */
    for (var clave in data) {
      if (data[clave] == null || data[clave] == '') {
        delete data[clave]; //eliminamos las claves nulas
      }
    }
    if (!!filters.base_business_partner_id || !!filters.logi_mark_id) {
      if (!!data.package_price || !!data.unit_price) {
        /* console.log(filters, data); */
        let response = await wsUpdateMasive('logi/price-list/' + id + '/massive-update', {
          filters,
          ...data,
        });
        if (response.success) {
          showNotify(response.message);
          listPrices(valueSearch);

          setMultiple({});
        } else {
          listPrices(valueSearch);
          showNotify(response.message, 'error');
          setMultiple({});
        }
      } else {
        showNotify('Seleccione un campo o más', 'info');
      }
    } else {
      showNotify('Seleccione al menos un filtro', 'info');
    }
  }

  async function discountMasive(filters) {
    let discount = document.getElementById('discountPackage').value;
    let variation = document.getElementById('variation').value;
    if (!!filters.base_business_partner_id || !!filters.logi_mark_id) {
      if (discount > 0) {
        let response = await wsUpdateMasive('logi/price-list/' + id + '/package-discount', {
          filters,
          package_discount: discount,
          variation: variation,
        });
        if (response.success) {
          showNotify(response.message);
          listPrices(valueSearch);
          setClearDiscountPackage(!clearDiscountPackage);
        } else {
          listPrices(valueSearch);
          showNotify(response.message, 'error');
        }
      } else {
        showNotify('Ingrese un monto válido', 'info');
      }
    } else {
      showNotify('Seleccione al menos un filtro', 'info');
    }
  }

  async function saveGlobalDiscount() {
    if (!!filters.base_business_partner_id || !!filters.logi_mark_id) {
      const response = await wsUpdateMasive('logi/price-list/' + id + '/massive-update', {
        filters,
        type: 'discount',
        variation: 'discount',
        discount: globalDiscount,
      });
      if (response.success) {
        listPrices(valueSearch);
        showNotify(response.message);
      } else {
        listPrices(valueSearch);
        showNotify(response.message, 'error');
      }
    } else {
      showNotify('Seleccione al menos un filtro', 'info');
    }
  }

  const columns = [
    {
      field: 'num',
      headerName: '#',
      width: 100,
      renderCell: (cellValues) => {
        return (
          <>
            <Button
              justIcon
              round
              simple
              color={props.themeContext.buttonColorWarning}
              onClick={() => {
                setOpen({
                  ...cellValues.row,
                  state: cellValues.row.state === 'Activo' ? 'A' : 'I',
                });
              }}
            >
              <Edit />
            </Button>
            <Button
              justIcon
              round
              simple
              color="primary"
              onClick={() => setPriceLogModel({ ...cellValues.row, open: true })}
            >
              <Visibility />
            </Button>
          </>
        );
      },
    },
    { field: 'category', headerName: 'Categoría', width: 200 },
    { field: 'family', headerName: 'Familia', width: 200 },
    { field: 'logi_mark_description', headerName: 'Marca', width: 200 },
    { field: 'ItemCode', headerName: 'Código', width: 150 },
    { field: 'ItemName', headerName: 'Producto', width: 370 },
    { field: 'state', headerName: 'Estado', width: 120 },
    {
      field: 'last_purchase_price',
      headerName: 'Ult. precio compra',
      type: 'number',
      width: 180,
    },
    {
      field: 'unit_margin',
      headerName: '%Margen unitario',
      type: 'number',
      width: 180,
    },
    {
      field: 'package_margin',
      headerName: '%Margen paquete',
      type: 'number',
      width: 180,
    },
    {
      field: 'unit_price',
      headerName: 'Precio Unit.',
      type: 'number',
      width: 150,
      editable: true,
      renderCell: (cellValues) => {
        return (
          <div>
            {cellValues.row.isRetained === 'Y' ? (
              <Tooltip
                title={parseFloat(
                  cellValues.row.previus_retained_unit_price || cellValues.row.unit_price || 0,
                ).toFixed(4)}
              >
                <div>{parseFloat(cellValues.row.unit_price || 0).toFixed(4)}</div>
              </Tooltip>
            ) : (
              parseFloat(cellValues.row.unit_price || 0).toFixed(4)
            )}
          </div>
        );
      },
    },
    {
      field: 'discount',
      headerName: '%Descuento',
      type: 'number',
      width: 150,
      editable: true,
    },
    {
      field: 'package_price',
      headerName: 'Precio Paq.',
      type: 'number',
      width: 150,
      editable: true,
      renderCell: (cellValues) => {
        return (
          <div>
            {cellValues.row.isRetained === 'Y' ? (
              <Tooltip
                title={parseFloat(
                  cellValues.row.previus_retained_package_price ||
                    cellValues.row.package_price ||
                    0,
                ).toFixed(4)}
              >
                <div>{parseFloat(cellValues.row.package_price || 0).toFixed(4)}</div>
              </Tooltip>
            ) : (
              parseFloat(cellValues.row.package_price || 0).toFixed(4)
            )}
          </div>
        );
      },
    },
  ];

  async function showDifferenceModal(fromListId, toList) {
    let res = await wsGetAll(
      `logi/price-list/differences?from_list_id=${fromListId}&to_list_id=${toList.id}`,
    );
    if (!res.success) {
      showNotify(res.message, 'error');
    }

    if (res.data.length === 0) {
      showNotify('No se encontraron diferencias', 'info');
      return;
    }

    setDifferenceList(toList);
    setDifferencePrices(res.data);
  }

  function filter(text) {
    let arrPrices = prices.filter(({ ItemName: ItemName1 }) =>
      ItemName1?.toLowerCase().includes(text.toLowerCase()),
    );

    if (arrPrices.length === 0 && text.length > 1) {
      arrPrices = prices.filter(({ ItemCode: ItemCode1 }) =>
        ItemCode1?.toLowerCase().includes(text.toLowerCase()),
      );
    }
    return arrPrices;
  }

  useEffect(() => {
    getPriceList();
  }, []);

  return (
    <Fragment>
      <Toasty action={notify} />

      <PriceLogModal model={priceLogModel} setOpen={setPriceLogModel} />

      <ModalPrice
        model={model}
        setOpen={setOpen}
        showNotify={showNotify}
        reload={() => listPrices(valueSearch)}
        priceList={priceList}
      />
      <UpdateListModal
        model={updateListModel}
        setOpen={setUpdateListModel}
        showNotify={showNotify}
        prices={prices}
        priceListId={id}
      />

      <DifferenceListModal
        priceListId={id}
        showNotify={showNotify}
        model={differenceListModel}
        setOpen={setDifferenceListModel}
        showDifferenceModal={showDifferenceModal}
      />

      <DifferenceListPricesModal
        priceList={priceList}
        toList={differenceList}
        setDifferenceList={setDifferenceList}
        differencePrices={differencePrices}
        setDifferencePrices={setDifferencePrices}
      />

      <GridContainer>
        <GridItem xs={12}>
          <GridContainer>
            <GridItem xs={12} style={{ marginTop: 10, fontWeight: 'bold', fontSize: 16 }}>
              <p>{priceList.ListName}</p>
            </GridItem>
          </GridContainer>
          <Card>
            <CardHeader icon>
              <CardIcon
                onClick={() => setOpen({})}
                pointer="true"
                color={props.themeContext.buttonColorSuccess}
              >
                <Add />
              </CardIcon>
              <h4 className={classes.cardIconTitle}>Listado de Precios</h4>
            </CardHeader>
            <CardBody>
              <GridContainer>
                <GridItem xs={12}>
                  <Button
                    color="warning"
                    disabled={prices.length === 0}
                    onClick={() => {
                      setUpdateListModel({ open: true });
                    }}
                  >
                    Actualizar precios de otra lista
                  </Button>
                  <Button
                    color="primary"
                    style={{ marginLeft: '10px' }}
                    onClick={() => {
                      setDifferenceListModel({ open: true });
                    }}
                  >
                    Comparar diferencias de listas
                  </Button>
                </GridItem>
              </GridContainer>

              <FilterArticle getFilter={listPrices} setValueSearch={setValueSearch} mark>
                <GridItem md={2} xs={12}>
                  <TextField
                    label="Buscar producto"
                    fullWidth
                    margin="normal"
                    onChange={(e) => {
                      setTextInput(e.target.value);
                    }}
                  />
                </GridItem>
              </FilterArticle>
              <GridContainer>
                <GridItem xs={12} md={5}>
                  <form
                    onSubmit={(e) => {
                      e.preventDefault();
                      updateMasive(filters, multiple);
                    }}
                  >
                    <Divider text="Variaciones" mt={15} color="#4caf50" />
                    <GridContainer>
                      <GridItem xs={12} md={6}>
                        <FormControl fullWidth margin="normal" size="small" required>
                          <InputLabel>Acción</InputLabel>
                          <Select
                            value={multiple.type || ''}
                            inputProps={{
                              name: 'type',
                              onChange: changeMultiple,
                            }}
                          >
                            <MenuItem value="increment">Aumentar</MenuItem>
                            <MenuItem value="decrement">Disminuir</MenuItem>
                            <MenuItem
                              value="exact"
                              onClick={() => {
                                setMultiple((multiple.variation = 'amount'));
                              }}
                            >
                              Fijar precio
                            </MenuItem>
                          </Select>
                        </FormControl>
                      </GridItem>
                      <GridItem xs={12} md={6}>
                        {multiple.type == 'exact' ? undefined : (
                          <FormControl fullWidth margin="normal" size="small" required>
                            <InputLabel>Variación</InputLabel>
                            <Select
                              value={multiple.variation || ''}
                              inputProps={{
                                name: 'variation',
                                onChange: changeMultiple,
                              }}
                            >
                              <MenuItem value="percentage">Porcentaje</MenuItem>
                              <MenuItem value="amount">Soles</MenuItem>
                            </Select>
                          </FormControl>
                        )}
                      </GridItem>
                      <GridItem xs={12} md={6}>
                        <TextField
                          label="Precio unitario"
                          name="unit_price"
                          type="number"
                          value={multiple.unit_price || ''}
                          fullWidth
                          margin="normal"
                          size="small"
                          disabled={multiple.type == 'exact' ? false : !multiple.variation}
                          onKeyPress={(e) => {
                            var key = window.event ? e.which : e.keyCode;
                            if (key === 101) {
                              return e.preventDefault();
                            }
                          }}
                          inputProps={{
                            onChange: changeMultiple,
                            min: 0,
                            step: 0.0001,
                          }}
                        />
                      </GridItem>
                      <GridItem xs={12} md={6}>
                        <TextField
                          label="Precio paquete"
                          name="package_price"
                          type="number"
                          value={multiple.package_price || ''}
                          fullWidth
                          margin="normal"
                          size="small"
                          onKeyPress={(e) => {
                            var key = window.event ? e.which : e.keyCode;
                            if (key === 101) {
                              return e.preventDefault();
                            }
                          }}
                          inputProps={{
                            onChange: changeMultiple,
                            min: 0,
                            step: 0.0001,
                          }}
                          disabled={multiple.type == 'exact' ? false : !multiple.variation}
                        />
                      </GridItem>
                    </GridContainer>
                    <Button
                      fullWidth
                      type="submit"
                      color={props.themeContext.buttonColorSuccess}
                      size="sm"
                    >
                      Aplicar
                    </Button>
                  </form>
                </GridItem>
                <GridItem xs={12} md={4}>
                  <Divider
                    text="Descuento precio paquete"
                    tooltipTitle="Reduce los precios por paquete en base a la variación seleccionada"
                    mt={15}
                    color="orange"
                  />
                  <GridContainer>
                    <GridItem xs={12} md={6}>
                      <FormControl
                        fullWidth
                        margin="normal"
                        size="small"
                        required
                        key={clearDiscountPackage}
                      >
                        <InputLabel>Variación</InputLabel>
                        <Select
                          value={packageVariation}
                          onChange={(e) => {
                            let value = e.target.value;
                            setPackageVariation(value);
                          }}
                          inputProps={{
                            name: 'variation',
                            id: 'variation',
                          }}
                        >
                          <MenuItem value="percentage">Porcentaje</MenuItem>
                          <MenuItem value="amount">Soles</MenuItem>
                        </Select>
                      </FormControl>
                    </GridItem>
                    <GridItem xs={12} md={6}>
                      <TextField
                        key={clearDiscountPackage}
                        id="discountPackage"
                        label={
                          packageVariation === 'percentage'
                            ? '% descuento'
                            : packageVariation === 'amount'
                            ? 'Monto descuento'
                            : 'Seleccionar'
                        }
                        type="number"
                        defaultValue=""
                        fullWidth
                        margin="normal"
                        size="small"
                        onKeyPress={(e) => {
                          var key = window.event ? e.which : e.keyCode;
                          if (key === 101) {
                            return e.preventDefault();
                          }
                        }}
                        inputProps={{
                          min: 0,
                          step: 0.0001,
                        }}
                      />
                    </GridItem>
                  </GridContainer>
                  <Button
                    fullWidth
                    type="submit"
                    color={props.themeContext.buttonColorSuccess}
                    size="sm"
                    onClick={() => discountMasive(filters)}
                  >
                    Descontar
                  </Button>
                </GridItem>
                <GridItem xs={12} md={3}>
                  <Divider
                    text="Descuento general"
                    tooltipTitle="Reduce los precios por el porcentaje ingresado"
                    mt={15}
                    color="red"
                  />
                  <div style={{ display: 'flex', alignItems: 'baseline' }}>
                    <TextField
                      label="Porcentaje"
                      type="number"
                      defaultValue=""
                      fullWidth
                      margin="normal"
                      size="small"
                      onKeyPress={onlyMoney}
                      onChange={(e) => setGlobalDiscount(e.target.value)}
                      inputProps={{ min: 0, step: 0.0001 }}
                    />
                    <Button
                      color="success"
                      size="sm"
                      style={{ marginLeft: 15 }}
                      onClick={saveGlobalDiscount}
                    >
                      Guardar
                    </Button>
                  </div>
                </GridItem>
              </GridContainer>

              <div style={{ width: '100%', marginTop: '20px' }}>
                <div style={{ height: 650, width: '100%' }} className={classes.root}>
                  <DataGrid
                    sx={{
                      '& .row-retained': {
                        backgroundColor: 'red',
                        '&:hover': { backgroundColor: 'red' },
                      },
                    }}
                    localeText={esES.props.MuiDataGrid.localeText}
                    columns={columns}
                    getRowClassName={(params) => {
                      return params.row.isRetained === 'Y' ? 'row-retained' : undefined;
                    }}
                    rows={filter(textInput).map((price, i) => {
                      return {
                        id: price.id,
                        num: i + 1,
                        category: price.logi_category_description,
                        family: price.logi_family_description,
                        logi_mark_description: price.logi_mark_description,
                        logi_product_id: price.logi_product_id,
                        ItemCode: price.ItemCode,
                        ItemName: price.ItemName,
                        state: price.state === 'A' ? 'Activo' : 'Inactivo',
                        logi_price_list_id: price.logi_price_list_id,
                        last_purchase_price: parseFloat(price.last_purchase_price || 0).toFixed(4),
                        unit_margin: price.unit_margin || 0,
                        package_margin: price.package_margin || 0,
                        unit_price: parseFloat(price.unit_price || 0).toFixed(4),
                        previus_retained_unit_price: price.previus_retained_unit_price,
                        discount: parseFloat(price.discount || 0).toFixed(4),
                        package_price: parseFloat(price.package_price || 0).toFixed(4),
                        previus_retained_package_price: price.previus_retained_package_price,
                        ListName: price.ListName,
                        isRetained: price.isRetained,
                      };
                    })}
                    onEditCellChangeCommitted={processSave}
                    onEditCellChange={(e) => setDataEdit({ ...dataEdit, ...e })}
                    pageSize={pageSize}
                    onPageSizeChange={handlePageSizeChange}
                    rowsPerPageOptions={[10, 20, 100]}
                    pagination
                  />
                </div>
              </div>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    </Fragment>
  );
});
